/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * A rule type specifies if a file is allowed, required, or disallowed.
 */
export const RuleType = /* #__PURE__ */ parsers.exactly('allow', 'deny', 'require');
